import { ModelingStatus } from ".";
import FetchApi from "../util/fetchApi";
import UpdateStore from "./updateStore";
const fetchApi = new FetchApi();

export default class DataSource extends UpdateStore {
  async getDatasourcesOnWorkspace(Workspace_id) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/datasources/coverage`)).data;
  }

  async getEntitiesOnWorkspace(Workspace_id) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/entities/list`)).data;
  }

  async getHealthChart(Workspace_id, datasource) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/healthchart/${datasource}`)).data;
  }

  async syncData(Workspace_id, data) {
    return (
      await fetchApi.post(`/data-modeling/${Workspace_id}/syncData`, data, (response) =>
        this.updateConfigStatus(response, response?.status)
      )
    ).data;
  }

  async regenerateModel(Workspace_id, data) {
    return (await fetchApi.post(`/data-modeling/${Workspace_id}/regenerateModel`, data)).data;
  }

  async isValidConfig(Workspace_id, data) {
    return (await fetchApi.post(`/data-modeling/${Workspace_id}/isValidConfig`, data)).data;
  }

  async rollbackToConfig(Workspace_id, Version_id) {
    return (
      await fetchApi.post(`/data-modeling/${Workspace_id}/${Version_id}`, undefined, (response) =>
        this.updateConfigStatus(response, ModelingStatus.Modified)
      )
    ).data;
  }

  async addDataSource(Workspace_id, data) {
    return (
      await fetchApi.post(`/data-modeling/${Workspace_id}/dataSource`, data, (response) =>
        this.updateConfigStatus(response, ModelingStatus.Modified)
      )
    ).data;
  }

  async updateDataSource(Workspace_id, dataSourceId, dataSource) {
    return (
      await fetchApi.post(`/data-modeling/${Workspace_id}/dataSource/${dataSourceId}`, dataSource, (response) =>
        this.updateConfigStatus(response, ModelingStatus.Modified)
      )
    ).data;
  }

  async deleteDataSource(Workspace_id, dataSourceId) {
    return (
      await fetchApi.delete(`/data-modeling/${Workspace_id}/dataSource/${dataSourceId}`, (response) =>
        this.updateConfigStatus(response, ModelingStatus.Modified)
      )
    ).data;
  }

  async addEntity(Workspace_id, data) {
    return (
      await fetchApi.post(`/data-modeling/${Workspace_id}/entity`, data, (response) =>
        this.updateConfigStatus(response, ModelingStatus.Modified)
      )
    ).data;
  }

  async updateEntity(Workspace_id, ObjectID, data) {
    return (
      await fetchApi.patch(`/data-modeling/${Workspace_id}/entity/${ObjectID}`, data, (response) =>
        this.updateConfigStatus(response, ModelingStatus.Modified)
      )
    ).data;
  }

  async getTags(Workspace_id, ObjectType) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/tags/${ObjectType}`)).data;
  }

  async deleteEntityNewWay(Workspace_id, ObjectID) {
    return (
      await fetchApi.delete(`/data-modeling/${Workspace_id}/entity/${ObjectID}`, (response) =>
        this.updateConfigStatus(response, ModelingStatus.Modified)
      )
    ).data;
  }

  async getLocationList(Workspace_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/dataconnection/getConnections`)).data.data;
  }

  async addLocationData(data, Workspace_id, dataProvider) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/dataconnection/connection/${dataProvider}`, data)).data;
  }

  async getDataLakeConnection(Workspace_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/dataconnection/getDataLakeConnection`)).data;
  }

  async getConfigHistoryList(Workspace_id) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/configHistory`)).data;
  }

  async getModifiedObjects(Workspace_id) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/modifiedObjects`)).data;
  }

  async compareConfigVersions(Workspace_id, Config_id, Compare_id) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/${Config_id}/compareWith/${Compare_id}`)).data;
  }

  async deleteConfigHistory(Workspace_id, data) {
    return (await fetchApi.post(`/data-modeling/${Workspace_id}/deleteConfigHistory`, data)).data;
  }

  async getTablesAndViews(Workspace_id, schemaName) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/tables/${schemaName}`)).data;
  }

  async getSchemas(Workspace_id) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/schemas`)).data;
  }

  async getChangeHistory(Workspace_id, Config_id, options) {
    return (await fetchApi.post(`/data-modeling/${Workspace_id}/changehistory/${Config_id}`, options)).data;
  }

  async downloadAppliedConfid(Workspace_id, Config_id, fileName) {
    return await fetchApi.download(`/data-modeling/${Workspace_id}/changehistory/${Config_id}`, {
      fileName,
    });
  }

  async getConfigStatus(Workspace_id) {
    return (
      await fetchApi.get(`/data-modeling/${Workspace_id}/status`, (response) =>
        this.updateConfigStatus(response, ModelingStatus[response?.data?.data?.Status])
      )
    ).data;
  }

  async createSnapshot(Workspace_id) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/snapshot`)).data;
  }

  async getObjectOverview(Workspace_id, ObjectType) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/overview/${ObjectType}`)).data;
  }

  async getObjectsListing(Workspace_id, ObjectType, tags) {
    return (await fetchApi.post(`/data-modeling/${Workspace_id}/listing/${ObjectType}`, { tags })).data;
  }

  async getAppliedListing(Workspace_id, ObjectType) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/appliedlisting/${ObjectType}`)).data;
  }

  async getAllObjectNames(Workspace_id) {
    return (await fetchApi.post(`/data-modeling/${Workspace_id}/allObjectNames`, {})).data;
  }

  async getObjectNamesByType(Workspace_id, objectType, jobType, Job_id) {
    return (
      await fetchApi.post(`/data-modeling/${Workspace_id}/objectListByType`, {
        jobType,
        objectType,
        Job_id,
      })
    ).data;
  }

  async getAllObjects(Workspace_id, ObjectType) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/detail/${ObjectType}`)).data;
  }

  async getMappedObjects(Workspace_id) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/mappedObjects`)).data;
  }

  async getObjectByID(Workspace_id, ObjectType, ObjectID) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/detail/${ObjectType}/${ObjectID}`)).data;
  }

  async getObjectRequiredInfo(Workspace_id, ObjectType) {
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/${ObjectType}/required-info`)).data;
  }

  async getConflictingObjects(Workspace_id, selectedObjects) {
    const { sources, entities } = selectedObjects;

    return (
      await fetchApi.post(`/data-modeling/${Workspace_id}/conflictingObjects`, {
        sources,
        entities,
      })
    ).data;
  }
}
